import { Boundaries } from "@planzone/core";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State } from "./types";

function handleFailure(
  state: State,
  project: Boundaries["retrieveNotifications"]["failure"],
): State {
  return { ...state, request: setRequestStateToFailure() };
}

export { handleFailure };
